<template>
    <PageWrapper>
        <template #headline>
            <fa icon="fa-solid fa-file-signature" />&nbsp;{{
                $t('payment_accounts')
            }}
        </template>

        <PaymentAccountsTable />
    </PageWrapper>
</template>

<script setup lang="ts">
import PageWrapper from '@src/partials/pages/PageWrapper.vue'
import PaymentAccountsTable from '@src/partials/paymentAccounts/PaymentAccountsTable.vue'
</script>
